export class StoreHandler<T> {
  protected stores: { [key: string]: T } = {};

  register = (key: string, createStore: () => T): T => {
    // // If in development mode and hot module replacement is enabled, create a new store instance
    // disable for now TODO: enable and skip for TeachingBlockStore (and possibly PinboardStore)
    // if (import.meta.env.DEV && import.meta.hot) {
    //   this.stores[key] = createStore();
    // } else if (!this.stores[key]) {
    //   this.stores[key] = createStore();
    // }
    if (!this.stores[key]) {
      this.stores[key] = createStore();
    }
    return this.stores[key];
  };

  get = (key: string): T => {
    return this.stores[key];
  };

  unregister = (key: string): void => {
    // Stores koennen Beobachter halten (z. B. die Reaction, die Ansichts-
    // einstellungen speichert). Wer einen Store verwirft, muss sie beenden.
    const store = this.stores[key] as { dispose?: () => void } | undefined;
    store?.dispose?.();
    delete this.stores[key];
  };
}
